<script setup lang="ts">
  import { MpCard } from '@borg/ui';
  import { JobDetailsSource, JobGroup, JobSimple } from '@borg/types';

  const props = withDefaults(
    defineProps<{
      item: JobGroup | JobSimple;
      source?: JobDetailsSource;
      isBorderedCard?: boolean;
      showOrganization?: boolean;
    }>(),
    {
      source: undefined,
      isBorderedCard: false,
      showOrganization: false,
    },
  );

  const jobCard = useJobCard.provide();
  jobCard.set(props.item, props.source);
  const organizationCard = useOrganizationCard.provide();
  organizationCard.set(props.item.organization);
</script>

<template>
  <MpCard
    class="job-card"
    :border="props.isBorderedCard ? 'light-only' : undefined"
    :p="props.isBorderedCard ? undefined : 'unset'"
    :corners="props.isBorderedCard ? undefined : 'square'"
  >
    <div class="job-card__content">
      <JobCardTags />
      <JobCardTitle />
      <JobCardSubtitle v-if="showOrganization" />
      <JobCardLocation />
      <JobCardDate :show-expired-label="false" />
      <slot />
    </div>
  </MpCard>
</template>

<style scoped lang="scss">
  .job-card {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    &__content {
      display: flex;
      flex-direction: column;
      gap: var(--mp-space-30);
    }
  }
</style>
